export default "__VITE_ASSET__C_gPWWIU__"